/**
 * DbEnvBanner (US-AIF.P0-0247-S03 · @UC9419 · @DP-5) — banner CẢNH BÁO bền vững khi env=sandbox, để
 * admin KHÔNG BAO GIỜ nhầm dữ liệu demo với dữ liệu thật. Render ở composition root (App.tsx). Sticky
 * top, màu cảnh báo semantic (warning tone — không chỉ trang trí), role="alert" (a11y đọc ngay). Kèm
 * nút "Về Thật" đưa nhanh về DB chính. Env=real ⇒ banner ẩn. Mirror ImpersonationBanner.
 */
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useDbEnv } from "./db-env-context.js";

export function DbEnvBanner() {
  const { t } = useTranslation();
  const { isSandbox, setDbEnv } = useDbEnv();

  // env=real → banner ẩn (chỉ hiện khi đang xem sandbox).
  if (!isSandbox) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      data-testid="db-env-banner"
      className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-3 border-b border-tone-warning-bd bg-tone-warning-bg px-4 py-2 text-tone-warning-fg"
    >
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        <span className="font-semibold uppercase tracking-wide">⚠️ {t("dbEnv.banner_title")}</span>
        <span className="text-tone-warning-fg opacity-90">{t("dbEnv.banner_desc")}</span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={() => setDbEnv("real")}
        aria-label={t("dbEnv.back_to_real")}
      >
        {t("dbEnv.back_to_real")}
      </Button>
    </div>
  );
}
